import { SiJavascript, SiReact, SiNodedotjs, SiNextdotjs, SiPython } from 'react-icons/si';
import { FaHeadset, FaNetworkWired, FaRobot } from 'react-icons/fa';

export const skills = [
  { name: "Suporte Técnico", icon: FaHeadset, color: "#64ffda" },
  { name: "Infraestrutura", icon: FaNetworkWired, color: "#64ffda" },
  { name: "IA e RAG", icon: FaRobot, color: "#64ffda" },
  { name: "JavaScript", icon: SiJavascript, color: "#F7DF1E" },
  { name: "React", icon: SiReact, color: "#61DAFB" },
  { name: "Node.js", icon: SiNodedotjs, color: "#339933" },
  { name: "Next.js", icon: SiNextdotjs, color: "#eef3f8" },
  { name: "Python", icon: SiPython, color: "#3776AB" },
];
